// extracted by mini-css-extract-plugin
export default {"root":"WarningModal_root__o8t4E","header":"WarningModal_header__LbVU3"};